import { send } from 'server';

export const acceptBonus = ({ bonusIdentifier, freeBetConfigurationId }) => send({
    ID: 31022,
    description: 'Bonus Message Accept Request',
    responses: [31024, 31023],
    accept: true,
    bonusIdentifier,
    freeBetConfigurationId,
    errorLevel: 1
});

export const declineBonus = ({ bonusIdentifier }) => send({
    ID: 31022,
    description: 'Bonus Message Decline Request',
    responses: [31024, 31023],
    accept: false,
    bonusIdentifier,
    errorLevel: 1
});
